import React, { ReactNode } from 'react';
import MyRequestCard from '../Cards/MyRequestCard';
import RemindersCard from '../Cards/RemindersCard';
import { Button, Alert } from "flowbite-react";
import { HiInformationCircle } from "react-icons/hi";

const RequestorDashboard: React.FC = () => {
    return (
        <>
            <Alert color="failure" icon={HiInformationCircle}>
                <span className="font-medium">Announcement!</span> Welcome to the new Online Purchasing System.
            </Alert>
            <div className="mt-4 grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                <MyRequestCard />
            </div>
        </>
    );
};

export default RequestorDashboard;